import { useNavigate } from "react-router-dom"
import {
  clearSelectedBrandID,
  selectSelectedBrandID,
  setSelectedBrandID
} from "../../../redux/slices/conversations"
import { useAppDispatch, useAppSelector, useUserRoles } from "../../hooks"
import { useFetchBrandsQuery } from "../../../redux/queries"
import BrandAutocomplete from "../brand-autocomplete"

const ConversationsBrandSelector = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { isSuperAdmin } = useUserRoles()

  const selectedBrandID = useAppSelector(selectSelectedBrandID)
  const { data: brands = [] } = useFetchBrandsQuery({ limit: 999 })

  if (!isSuperAdmin || brands.length < 2) return null

  const handleChange = (value: string) => {
    if (value) {
      dispatch(setSelectedBrandID(parseInt(value)))
    } else {
      dispatch(clearSelectedBrandID())
    }
    navigate("/conversations/sms")
  }

  return (
    <div className="mt-3">
      <BrandAutocomplete
        hideLabel
        brands={brands}
        selected={selectedBrandID?.toString() ?? ""}
        onChange={handleChange}
        direction="vertical"
      />
    </div>
  )
}

export default ConversationsBrandSelector
